module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "settings": _vm.settings,
      "disabled": Boolean(_vm.validationErrors)
    },
    on: {
      "save": _vm.save,
      "show": _vm.dialogShown
    }
  }, [_c('div', {
    staticClass: "pa-3 full-width",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "flex-basis": "200px"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "180px",
      "color": "#ddd"
    }
  }, [_vm._v("mdi-face-agent")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_c('DateTime', {
    staticClass: "mb-4",
    attrs: {
      "date-only": "",
      "past": ""
    },
    model: {
      value: (_vm.charge.date),
      callback: function($$v) {
        _vm.$set(_vm.charge, "date", $$v)
      },
      expression: "charge.date"
    }
  }), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "return-object": false,
      "items": _vm.chargeDescriptions,
      "label": "Description",
      "hide-details": ""
    },
    on: {
      "change": _vm.updatePrice
    },
    model: {
      value: (_vm.charge.description),
      callback: function($$v) {
        _vm.$set(_vm.charge, "description", $$v)
      },
      expression: "charge.description"
    }
  }), _vm._v(" "), _c('CurrencyBox', {
    staticClass: "mt-2",
    attrs: {
      "label": "Amount"
    },
    model: {
      value: (_vm.charge.amount),
      callback: function($$v) {
        _vm.$set(_vm.charge, "amount", $$v)
      },
      expression: "charge.amount"
    }
  }), _vm._v(" "), _c('UserChooser', {
    staticClass: "mb-3",
    attrs: {
      "label": "Broker"
    },
    model: {
      value: (_vm.charge.to),
      callback: function($$v) {
        _vm.$set(_vm.charge, "to", $$v)
      },
      expression: "charge.to"
    }
  }), _vm._v(" "), _c('UserChooser', {
    staticClass: "mb-3",
    attrs: {
      "label": "Processor"
    },
    model: {
      value: (_vm.charge.from),
      callback: function($$v) {
        _vm.$set(_vm.charge, "from", $$v)
      },
      expression: "charge.from"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Clients"
    },
    model: {
      value: (_vm.charge.clients),
      callback: function($$v) {
        _vm.$set(_vm.charge, "clients", $$v)
      },
      expression: "charge.clients"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small-text light-text"
  }, [_vm._v("Broker Name: " + _vm._s(_vm.charge.brokerName))])], 1)]), _vm._v(" "), _c('template', {
    slot: "footer"
  }, [(_vm.validationErrors) ? _c('v-tooltip', {
    attrs: {
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({
          attrs: {
            "color": "red"
          }
        }, on), [_vm._v("errors")])]
      }
    }], null, false, 3195893709)
  }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.validationErrors))])]) : _vm._e()], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69db288a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/ChargeDialog.vue
// module id = 2588
// module chunks = 1